// extracted by mini-css-extract-plugin
export var content = "_4w-3";
export var list = "_4w-4";
export var settingsContent = "_4w-7";
export var settingsPanel = "_4w-8";
export var state = "_4w-6";
export var triggerBadge = "_4w-2";
export var triggerButton = "_4w-1";
export var triggerShell = "_4w-0";
export var unreadDot = "_4w-5";